import useTrigger from "./useTrigger";

/**
 * Custom hook that listens for a "keydown" event and triggers a callback function
 * if a specified condition is met.
 *
 * @param {Function} callback - The function to execute when the condition is true and a key is pressed.
 * @param {boolean} condition - A boolean value that determines whether the callback should be executed.
 */
function useKeydown(callback, conditions = []) {
  useTrigger("keydown", (e) => {
    if (conditions.every((c) => c)) callback(e);
  });
}

export default useKeydown;
